"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _underscore = require("underscore");
var _attachAudioPresenterSources = require("@studio/sources/attachAudioPresenterSources");
var _getSources = require("@studio/sources/getSources");
var _checkSourceTypes = require("@studio/sources/checkSourceTypes");
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
var _Sources = require("@studio/constants/Sources");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _Vendor = require("@studio/constants/Vendor");
var _utils = require("../../utils");
var _setSceneLayout = _interopRequireDefault(require("../program/setSceneLayout"));
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeMuteStatuses"));
var _clearStagedSources = _interopRequireDefault(require("./clearStagedSources"));
var _setMultipleDesiredAttendeeCameraStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeCameraStatuses"));
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _toggleMultipleAgoraAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/toggleMultipleAgoraAttendeeMuteStatuses"));
var _toggleMultipleAgoraAttendeeCameraStatuses = _interopRequireDefault(require("../attendee/toggleMultipleAgoraAttendeeCameraStatuses"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var logger = new _StudioLogger.StudioLogger('program-update');
function takeStagedSourcesLive(updateSource, setProgram) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState) {
    var _meetingResponse$Meet;
    var _getState = getState(),
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      banners = _getState.banners,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      attendeeCameraStatus = _getState.attendeeCameraStatus,
      broadcastSources = _getState.broadcastSources.sources,
      _getState$stagedSourc = _getState.stagedSources,
      stagedSources = _getState$stagedSourc.sources,
      stagedLayout = _getState$stagedSourc.sceneLayout,
      featuredPresenterId = _getState.featuredPresenter,
      _getState$broadcastSe = _getState.broadcastSettings,
      dragAndDrop = _getState$broadcastSe.dragAndDrop,
      autoMutePresenters = _getState$broadcastSe.autoMutePresenters,
      program = _getState.program,
      serverTimeDelta = _getState.serverTimeDelta,
      meetingResponse = _getState.meeting.meetingResponse,
      brandingSettings = _getState.brandingSettings;
    var useAgora = config.vendor === _Vendor.VENDOR_AGORA;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var layout = stagedLayout || sceneLayout;
    var stagedSourceIds = Object.keys(stagedSources).filter(function (sourceId) {
      return stagedSources[sourceId];
    });
    var sourcesToUpdate = [];
    var allStagedSources = broadcastSources.filter(function (bs) {
      return _toConsumableArray(stagedSourceIds).includes(bs._id);
    }).map(function (source) {
      return _objectSpread(_objectSpread({}, source), {}, {
        featured: source._id === featuredPresenterId,
        hidden: false
      });
    }).map(function (source) {
      if ((0, _utils.isMediaSource)(source.type)) {
        var wasInProgram = program.layers && program.layers.filter(function (ls) {
          return ls.source._id === source._id;
        }).length > 0;
        // if this was not in the program we set seek to 0 and startedOn
        if (!wasInProgram) {
          source = _objectSpread(_objectSpread({}, source), {}, {
            value: _objectSpread(_objectSpread({}, source.value), {}, {
              seek: 0,
              isPlaying: true,
              startedOn: (0, _utils.getStartedOn)(true, serverTimeDelta)
            })
          });
        }
        // if it is an audio source we need set hidden to false so that the
        // scene builder does not exclude it
        if ((0, _checkSourceTypes.isAudioSource)(source)) source.hidden = false;
        sourcesToUpdate.push(source);
        return source;
      }
      return source;
    });
    var _partition = (0, _underscore.partition)(allStagedSources, _checkSourceTypes.isCameraPresenter),
      _partition2 = _slicedToArray(_partition, 2),
      allStagedCamSources = _partition2[0],
      restStagedSources = _partition2[1];
    // slice camera sources
    var maxCameraLimit = useAgora ? _Sources.MAX_AGORA_CAMERA_COUNT : _SceneLayouts.CAMERA_PRESENTER_LIMIT;
    var stagedCamSources = allStagedCamSources.slice(0, Math.min(allStagedCamSources.length, maxCameraLimit));
    var sources = [].concat(_toConsumableArray(stagedCamSources), _toConsumableArray(restStagedSources));
    var meetingId = meetingResponse === null || meetingResponse === void 0 || (_meetingResponse$Meet = meetingResponse.Meeting) === null || _meetingResponse$Meet === void 0 ? void 0 : _meetingResponse$Meet.MeetingId;
    var camSourcesInProgram = (0, _getSources.getCameraPresenterSources)(program.layers);
    var stagedCamSourcesIds = stagedCamSources.map(function (source) {
      return source._id;
    });
    Object.entries(camSourcesInProgram).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        srcID = _ref2[0],
        src = _ref2[1];
      if (!stagedCamSourcesIds.includes(srcID)) {
        var logPayload = {
          'studio.actionName': 'Take Staged Sources Live',
          'studio.attendeeTileStatus': 'OFF-STAGE',
          'studio.tileAttendeeId': src.value,
          title: "ProgramUpdate: Attendee ".concat(src.value, " in meeting ").concat(meetingId, " is removed from the stage")
        };
        logger.info(logPayload.title, logPayload);
      }
    });
    stagedCamSources.filter(function (source) {
      return !camSourcesInProgram[source._id];
    }).forEach(function (src) {
      var logPayload = {
        'studio.actionName': 'Take Staged Sources Live',
        'studio.attendeeTileStatus': 'ON-STAGE',
        'studio.tileAttendeeId': src.value,
        title: "ProgramUpdate: Attendee ".concat(src.value, " in meeting ").concat(meetingId, " is added to the stage")
      };
      logger.info(logPayload.title, logPayload);
    });
    (0, _reactRedux.batch)(function () {
      /**
       * Set the desired attendee camera status to on if it is off.
       */
      var updatedCameraStatuses = {};
      sources.forEach(function (source) {
        var sourceValue = (0, _getSources.getSourceValue)(source);
        var isAttendeeCameraOn = !!attendeeCameraStatus[sourceValue];
        if (!isAttendeeCameraOn && !source.cameraUnavailable) {
          updatedCameraStatuses[sourceValue] = true;
        }
      });
      if (!(0, _underscore.isEmpty)(updatedCameraStatuses)) {
        if (useAgora) {
          dispatch((0, _toggleMultipleAgoraAttendeeCameraStatuses["default"])(updatedCameraStatuses));
        } else {
          dispatch((0, _setMultipleDesiredAttendeeCameraStatuses["default"])(updatedCameraStatuses));
        }
      }

      /** Audio/Video sources to make update */
      sourcesToUpdate.forEach(function (source) {
        dispatch(updateSource(source._id, {
          value: source.value,
          hidden: source.hidden
        }));
      });
    });
    var sceneSources = dragAndDrop ? (0, _utils.orderSources)(sources) : sources;

    /**
     * When taking sources live we attach audioPresenters for all unmuted camera sources.
     * We use this next unmuted attendees state only when autoMutePresenters setting is enabled otherwise maintain status quo
     */
    var nextMuteStatuses = autoMutePresenters ? (0, _utils.getAttendeesNextMuteStatuses)(sources, broadcastSources) : attendeeMuteStatus;
    var withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(sceneSources, nextMuteStatuses);
    var scene = (0, _sceneBuilder.sceneBuilder)(layout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);

    /** Update all staged attendees mute status */
    if (autoMutePresenters) {
      if (useAgora) {
        dispatch((0, _toggleMultipleAgoraAttendeeMuteStatuses["default"])(nextMuteStatuses));
      } else {
        dispatch((0, _setMultipleDesiredAttendeeMuteStatuses["default"])(nextMuteStatuses));
      }
    }
    dispatch(setProgram(scene));
    (0, _sendToDatadogWithIds.logProgramChange)(getState, 'takeStagedSourcesLive action');
    if (!(0, _underscore.isEqual)(sceneLayout, stagedLayout)) {
      dispatch((0, _setSceneLayout["default"])(layout));
    }

    // Finally clear all selections
    dispatch((0, _clearStagedSources["default"])());
  };
}
var _default = exports["default"] = takeStagedSourcesLive;